import buildMeta from '../utils/buildMeta'

const routes = [
  {
    name: 'jobs',
    path: '/jobs',
    component: () => import('@/pages/JobFeed/Jobs.vue'),
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      title: 'Jobs - Jobscan',
      description: 'Find your next job.',
    }),
  },
]

export default routes
